/**
 * GA4 events for lead capture attempts vs Airtable storage outcomes.
 */

import { getLeadCaptureFields } from './utils/attribution';

export function trackLeadCaptureEvent(eventName, { source, calculatorTier, leadStored, error } = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const params = {
    event_category: 'lead_generation',
    source: source || 'unknown',
    calculator_tier: calculatorTier || 'unknown'
  };
  if (leadStored != null) params.lead_stored = leadStored ? 1 : 0;
  if (error) params.error_message = String(error).slice(0, 100);
  window.gtag('event', eventName, params);
}

export async function postCalculatorLeadCapture(payload) {
  const attribution = getLeadCaptureFields();
  const response = await fetch('/.netlify/functions/capture-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...attribution, ...payload })
  });
  let data = {};
  try {
    data = await response.json();
  } catch (_) {
    /* ignore non-JSON */
  }
  return { ok: response.ok, data };
}
